import jobServices from 'ApiService/Placement/jobServices';
import Card from 'components/card';
import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
import AllStudents from './AllStudents';
import SelectClass from '../SelectClass';

const Index = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [classData, setClassData] = useState({ courseId: '', batchId: '' });
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [selectedStudent, setSelectedStudent] = useState(null);

  const router = useNavigate();
  const { state } = useContext(AuthContext);

  const steps = [
    { stepNo: 1, name: 'Class Info' },
    { stepNo: 2, name: 'Add Details' },
  ];

  // Fetch available courses
  const fetchCourses = async () => {
    setLoadingCourses(true);
    try {
      const response = await jobServices.getCourseBatch();
      if (response.data.success) {
        setCourses(response.data.courses);
      } else {
        toast.error('Failed to fetch courses.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch courses.');
    } finally {
      setLoadingCourses(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const handleNext = () => {
    if (!disable) setCurrentStep((prev) => prev + 1);
  };

  const handleBack = () => {
    if (selectedStudent) {
      setSelectedStudent(null);
    } else {
      setCurrentStep((prev) => (prev > 1 ? prev - 1 : prev));
    }
  };

  const displayStep = (step) => {
    switch (step.stepNo) {
      case 1:
        return (
          <SelectClass
            setLoading={setLoading}
            setDisable={setDisable}
            setClassData={setClassData}
            classData={classData}
            courses={courses}
            loadingCourses={loadingCourses}
          />
        );
      case 2:
        return (
          <AllStudents
            setLoading={setLoading}
            setDisable={setDisable}
            classData={classData}
            setClassData={setClassData}
            courses={courses}
            loadingCourses={loadingCourses}
            selectedStudent={selectedStudent}
            setSelectedStudent={setSelectedStudent}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
      <div
        className={`mx-auto h-full ${
          currentStep === 1 ? 'w-5/6' : 'w-6/6'
        } md:px-3 3xl:w-7/12`}
      >
        <Card extra="-mt-[280px] w-full md:-mt-[340px] md:px-[70px] h-full mx-auto pb-3">
          <div className="w-full rounded-[20px]">
            <UseContextProvider>
              {displayStep(steps[currentStep - 1])}
            </UseContextProvider>
          </div>
          <div className="flex flex-col justify-between px-3 pt-2 md:flex-row md:px-8">
            {(currentStep > 1 || selectedStudent) && (
              <button
                onClick={handleBack}
                className="mb-3 cursor-pointer rounded-xl bg-lightPrimary px-16 py-2 font-medium text-navy-700 transition duration-200 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20 md:mb-0"
              >
                {selectedStudent ? 'Back to Students' : 'Prev'}
              </button>
            )}
            <div className="ml-auto">
              {currentStep < steps.length && !selectedStudent && (
                <button
                  disabled={disable}
                  onClick={handleNext}
                  className="linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90"
                >
                  Next
                </button>
              )}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Index;
